import React from "react";
import { useState, useEffect } from "react";
import { DraggableContainer, DraggableChild } from "react-dragline";
import { useStoreState, useStoreActions } from "easy-peasy";
import _ from "lodash";
import ElementDragResize from "../../comp/pdf/ElementDragResize";
import { FaCopy, FaTrash } from "react-icons/fa";

export default function DraglineOverlay(props) {
  const [flag, setFlag] = useState(false);
  const [hoveredElement, setHoveredElement] = useState(null);
  const duplicateFormElementPDF = useStoreActions((actions) => actions.duplicateFormElementPDF);
  const removeFormElementsPDF = useStoreActions((actions) => actions.removeFormElementsPDF);
  const editorDisplay = useStoreState((state) => state.editorDisplay);
  const setEditorDisplay = useStoreActions((actions) => actions.setEditorDisplay);
  const formElementsPDF = useStoreState((state) => state.formElementsPDF);
  const updFormElementsPDF = useStoreActions((actions) => actions.updFormElementsPDF);

  // const formElementsPDF = useStoreState((state) => state.formElementsPDF);
  // const elementsOnPdf = useStoreState((state) => state.elementsOnPdf);
  // const [elementsOnPdf, setElementsOnPdf] = useState([]);
  // const [initialDraggableEl, setInitialDraggableEl] = useState(props.initialDraggableEl);
  // const getInitialElementsOnPdf = useStoreActions((actions) => actions.getInitialElementsOnPdf);
  // const updElementsOnPdfPsn = useStoreActions((actions) => actions.updElementsOnPdfPsn);

  // useEffect(() => {
  //   getInitialElementsOnPdf();
  // }, [getInitialElementsOnPdf]);

  // useEffect(() => {
  //   setElementsOnPdf(() => {
  //     let el = formElementsPDF.map((item) => {
  //       return item.elementOnPdf;
  //     });
  //     return el;
  //   });
  //   console.log({ elementsOnPdf });
  // }, [formElementsPDF]);

  const containerStyle = {
    position: "relative",
    width: `630px`,
    height: `810px`,
    boxShadow: "0 0 5px 1px #CCC inset",
    // background: "#F5F8FA",
    color: "#4A4A4A",
    margin: 0,
  };

  const childStyle = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    cursor: "move",
  };

  const handleDuplicate = (e, el) => {
    e.stopPropagation();
    duplicateFormElementPDF({ id: el.id, sub_id: el.sub_id });
  };

  const handleDelete = (e, el) => {
    e.stopPropagation();
    const confirmed = window.confirm(`Are you sure you want to delete this element?`);
    if (confirmed) {
      removeFormElementsPDF(el.id);
    }
  };

  const handleDoubleClick = (e, el) => {
    e.stopPropagation();
    
    if (editorDisplay) {
      // If editor is open, close it
      setEditorDisplay(false);
      updFormElementsPDF(
        formElementsPDF.map((item) => {
          item.isEdit = false;
          return item;
        })
      );
    } else {
      // If editor is closed, open it for this element
      setEditorDisplay(true);
      updFormElementsPDF(
        formElementsPDF.map((item) => {
          if (item.i === el.id) {
            item.isEdit = true;
          } else {
            item.isEdit = false;
          }
          return item;
        })
      );
    }
  };

  const renderDraggableChild = (el) => {
    let background = el.background;
    const elementKey = `${el.id}_${el.sub_id}`;
    const isHovered = hoveredElement === elementKey;
    
    return (
      <DraggableChild
        key={`group_id_${el.id}_sub_id${el.sub_id}`}
        defaultPosition={el.position}
        onStart={(e, b) => props.hangleStartDragg(e, b, el.id, el.sub_id)}
        onStop={(e, b) => props.handleStopDragg(e, b, el.id, el.sub_id)}
      >
        <div
          className="item"
          style={{
            ...childStyle,
            background,
            position: "relative",
            // width: size,
            // height: size,
          }}
          onMouseEnter={() => {
            setFlag(true);
            setHoveredElement(elementKey);
          }}
          onMouseLeave={() => {
            setFlag(false);
            setHoveredElement(null);
          }}
          onDoubleClick={(e) => handleDoubleClick(e, el)}
        >
          <ElementDragResize flag={flag} width={el.width} height={el.height} id={el.id} sub_id={el.sub_id} />
          {isHovered && (
            <>
              <button
                onClick={(e) => handleDuplicate(e, el)}
                style={{
                  position: "absolute",
                  top: "-10px",
                  right: "-20px",
                  width: "22px",
                  height: "22px",
                  borderRadius: "50%",
                  border: "1px solid #2563eb",
                  backgroundColor: "#fff",
                  color: "#2563eb",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: 0,
                  boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                  zIndex: 1000,
                }}
                title="Duplicate element"
              >
                <FaCopy size={11} />
              </button>
              <button
                onClick={(e) => handleDelete(e, el)}
                style={{
                  position: "absolute",
                  top: "15px",
                  right: "-20px",
                  width: "22px",
                  height: "22px",
                  borderRadius: "50%",
                  border: "1px solid #dc2626",
                  backgroundColor: "#fff",
                  color: "#dc2626",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: 0,
                  boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                  zIndex: 1000,
                }}
                title="Delete element"
              >
                <FaTrash size={10} />
              </button>
            </>
          )}
          {/* <span>drag me</span> */}
        </div>
      </DraggableChild>
    );
  };

  return (
    <div
      key={props.pageNum}
      className="dragOverlay"
      style={{ position: "absolute" }}
      onPointerOver={(e) => props.handlePointerOver(e, props.pageNum)}
    >
      <style>{".active { opacity: .5;} .item{z-index: 100;}"}</style>

      <DraggableContainer key={props.pageNum} style={containerStyle} limit={props.keepElInside}>
        {/* {initialDraggableEl */}
        {props.elToRender
          .filter((item) => item.addToPdf === true)
          .filter((item) => item.pdfPage === props.pageNum)
          .map((item) => renderDraggableChild(item))}
      </DraggableContainer>
    </div>
  );
}
